import type { FC } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '@pp/core/src/store/CoreStore';

import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../store/slices/highflyerGame/slice';

import { CrashStreamControlPlain } from './CrashStreamControlPlain';

export const CrashStreamControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const isAnimationEnabled = useHighflyerGameStateSlice.getAnimationToggle();

  const handleToggle = useCallback(() => {
    dispatch(highflyerGameStateActions.isAnimationToggle());
  }, [dispatch]);

  return <CrashStreamControlPlain active={!isAnimationEnabled} onClick={handleToggle} />;
};
